/*
 * FESCHD Gratisartikel-Modul (Cart-Drawer) – AKTIONS-MODUS
 *
 * Architektur seit 25.08.2026: Die Standard-Gratis-Trinkflasche zu den
 * Hüllen-Bundles läuft serverseitig über die Shopify-Bundles-App
 * (0-€-Komponente), NICHT über dieses Skript.
 * Details: snippets/feschd-free-gift.liquid + documentation.txt.
 *
 * Aufgaben:
 * 1. Klick auf eine Option (Auswahl-UI ODER Stufe-2-Wahlkarten im
 *    Statusbalken-Modus) -> Geschenk hinzufügen/abwählen/tauschen (Cart AJAX
 *    API). Abwahl wird PRO VARIANTE für die Session gemerkt
 *    (feschdGiftOptoutIds), damit der Auto-Add nichts aufdrängt.
 *    TAUSCH INNERHALB EINER STUFE: Liegt bereits ein ANDERES Geschenk
 *    derselben Stufe im Warenkorb, wird direkt getauscht.
 * 2. AUTO-ADD (Setting gift_auto_add, data-auto-add="1"):
 *      - Stufe 1 erreicht  -> Tier-1-Artikel rein (genau 1 konfiguriert)
 *      - Stufe 2 erreicht  -> ALLE Tier-2-Artikel ZUSÄTZLICH rein (1 oder 2)
 *        AUSSER data-tier2-choice="1": Dann wählt der Kunde per Wahlkarte
 *        GENAU EINEN der Tier-2-Artikel (Anteil für Stufe 2 = 1).
 *    DUPLIKAT-SCHUTZ (UMBAU 28.08. nachmittags): prüft NUR noch GESCHENK-
 *    Zeilen (Property _feschd_gift). Legt der Kunde Flasche/Mount SELBST als
 *    reguläre Position in den Warenkorb, ist das ein normaler KAUF – das
 *    Geschenk-Exemplar kommt trotzdem ZUSÄTZLICH dazu. Der Rabatt setzt genau
 *    1 Einheit je Geschenk-Variante auf 0 €; jede weitere (gekaufte) Einheit
 *    wird normal berechnet.
 *    SPERR-LOGIK (feschdGiftAutoAddedIds):
 *      - Flag wird bei ERFOLGREICHEM Auto-Add gesetzt.
 *      - Entfernt UNSER Aufräumen die Zeile (Stufe unterschritten, Überzahl),
 *        wird das Flag GELÖSCHT -> erneutes Erreichen der Stufe fügt wieder
 *        hinzu (rauf/runter/rauf ist normales Shopping!).
 *      - Entfernt der KUNDE die Zeile manuell, bleibt das Flag stehen ->
 *        kein erneutes Aufdrängen in dieser Session.
 *      - LEERER WARENKORB setzt ALLE Session-Sperren zurück.
 * 3. BUNDLE-SKIP BEIM CHECKOUT (data-skip-handles, UMBAU 28.08.2026):
 *    Das Stufe-1-Geschenk bleibt IMMER sichtbar im Warenkorb liegen (Zero-
 *    Price-Effekt – der Kunde soll es sehen), AUCH wenn ein Hüllen-Bundle
 *    die Flasche bereits als Bundle-Komponente enthält. Erst beim Klick auf
 *    den Checkout-Button (Submit mit name="checkout", Drawer UND Cart-Seite)
 *    wird geprüft: Liegt ein Produkt aus der Skip-Liste im Warenkorb UND eine
 *    Tier-1-Geschenk-Zeile? Dann wird die Geschenk-Zeile entfernt (sonst
 *    doppelte Flasche im Auftrag!) und der Checkout danach normal fortgesetzt
 *    (requestSubmit mit Submitter; Fallback hidden input + submit()).
 *    Ohne Treffer läuft der Submit unverändert weiter.
 * 4. Konsistenz bei jeder Warenkorbänderung (evaluate):
 *    - Erlaubte Anzahl (Auto-Add-Modus): Stufe 1 (ab Schwelle 1: 1 Artikel,
 *      Bundle-Skip spielt hier KEINE Rolle mehr) + Stufe-2-Anteil (bei
 *      erreichter Stufe 2: 1 im Wahl-Modus, sonst Anzahl konfigurierter
 *      Tier-2-Artikel). Auswahl-Modus unverändert: Stufe 1 -> 1, Stufe 2 -> 2.
 *    - QUALIFIZIERENDER BETRAG (Stand 28.08. nachmittags, deckungsgleich mit
 *      der Rabatt-Collection "Alle Produkte"):
 *        a) Geschenk-Zeilen (Property _feschd_gift) zählen NIE.
 *        b) Reguläre Zeilen der TIER-1-Variante (Trinkflasche) zählen NIE –
 *           die Flasche liegt bewusst NICHT in der Rabatt-Collection, weil
 *           der Checkout-Skip die Geschenk-Flasche bei Hüllen-Bundles
 *           entfernt und eine mitzählende Flasche dabei die Stufe-2-Schwelle
 *           (128 €) reißen würde.
 *        c) Reguläre Zeilen der TIER-2-Varianten (Überall Mount) zählen MIT
 *           (Mount liegt in der Rabatt-Collection) – und zwar mit dem
 *           ORIGINAL-Zeilenpreis, damit der Wert stabil bleibt, egal auf
 *           welche der beiden Mount-Zeilen (Kauf/Geschenk) Shopify den
 *           100%-Rabatt bucht (sonst Flatter-Schleife: Rabatt senkt total ->
 *           Stufe weg -> Geschenk raus -> Rabatt weg -> Stufe wieder da ...).
 *        d) Alle übrigen Zeilen mit final_line_price.
 *    - Tier-2-Artikel fliegen raus, wenn Stufe 2 unterschritten wird.
 *    - Bei zu vielen Geschenken werden die NEUESTEN zuerst entfernt.
 *    - Menge jedes Geschenks immer 1.
 *    - Keine Aktion aktiv, aber Geschenke im Cart -> werden entfernt.
 * 5. Trigger: Initial-Load, Prestige-Events 'cart:change' + 'cart:refresh',
 *    MutationObserver auf Drawer-Re-Renders.
 * Nach eigenen Änderungen wird der Drawer per 'cart:refresh' neu gerendert.
 */
(function () {
  if (window.FeschdFreeGift) return;
  window.FeschdFreeGift = true;

  var busy = false;
  var evaluateTimer = null;
  var OPTOUT_IDS_KEY = 'feschdGiftOptoutIds';
  var AUTOADDED_IDS_KEY = 'feschdGiftAutoAddedIds';

  function getModule() {
    return document.getElementById('feschd-free-gift');
  }

  function setBusy(state) {
    busy = state;
    var mod = getModule();
    if (mod) mod.setAttribute('aria-busy', state ? 'true' : 'false');
  }

  function readIdList(key) {
    try {
      return (sessionStorage.getItem(key) || '')
        .split(',')
        .map(function (s) { return Number(s); })
        .filter(function (n) { return n > 0; });
    } catch (e) { return []; }
  }

  function addToIdList(key, variantId) {
    try {
      var list = readIdList(key);
      if (list.indexOf(variantId) === -1) {
        list.push(variantId);
        sessionStorage.setItem(key, list.join(','));
      }
    } catch (e) { /* egal */ }
  }

  function removeFromIdList(key, variantId) {
    try {
      var list = readIdList(key).filter(function (n) { return n !== variantId; });
      if (list.length) {
        sessionStorage.setItem(key, list.join(','));
      } else {
        sessionStorage.removeItem(key);
      }
    } catch (e) { /* egal */ }
  }

  function clearSessionFlags() {
    try {
      sessionStorage.removeItem(OPTOUT_IDS_KEY);
      sessionStorage.removeItem(AUTOADDED_IDS_KEY);
    } catch (e) { /* egal */ }
  }

  function hasSessionFlags() {
    try {
      return !!(sessionStorage.getItem(OPTOUT_IDS_KEY) || sessionStorage.getItem(AUTOADDED_IDS_KEY));
    } catch (e) { return false; }
  }

  function isOptedOut(variantId) {
    return readIdList(OPTOUT_IDS_KEY).indexOf(variantId) !== -1;
  }

  function wasAutoAdded(variantId) {
    return readIdList(AUTOADDED_IDS_KEY).indexOf(variantId) !== -1;
  }

  function readConfig(mod) {
    function idList(str) {
      return (str || '')
        .split(',')
        .map(function (s) { return Number(s); })
        .filter(function (n) { return n > 0; });
    }
    function handleList(str) {
      return (str || '')
        .toLowerCase()
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(function (s) { return s.length > 0; });
    }
    return {
      threshold1: Number(mod.dataset.threshold),
      threshold2: Number(mod.dataset.threshold2 || 0),
      tier1Variants: idList(mod.dataset.tier1Variants),
      tier2Variants: idList(mod.dataset.tier2Variants),
      skipHandles: handleList(mod.dataset.skipHandles),
      autoAdd: mod.dataset.autoAdd === '1',
      tier2Choice: mod.dataset.tier2Choice === '1',
      actionActive: mod.dataset.actionActive === '1'
    };
  }

  /* Bundle-Skip-Erkennung: liegt ein Produkt aus der Skip-Liste (reguläre
     Position) im Warenkorb, ist das Tier-1-Geschenk bereits als Bundle-
     Komponente enthalten. Wird NUR beim Checkout-Klick ausgewertet. */
  function tier1Skipped(cart, cfg) {
    if (!cfg.skipHandles.length) return false;
    return cart.items.some(function (i) {
      return !isGift(i) && cfg.skipHandles.indexOf(String(i.handle || '').toLowerCase()) !== -1;
    });
  }

  function allowedCount(total, cfg) {
    if (!cfg.actionActive) return 0;
    var tier2Reached = cfg.threshold2 > 0 && total >= cfg.threshold2;
    if (cfg.autoAdd) {
      var allowed = 0;
      if (total >= cfg.threshold1) allowed += 1;
      if (tier2Reached) {
        if (cfg.tier2Choice) {
          allowed += 1;
        } else {
          allowed += Math.max(cfg.tier2Variants.length, 1);
        }
      }
      return allowed;
    }
    if (tier2Reached) return 2;
    if (total >= cfg.threshold1) return 1;
    return 0;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function isGift(item) {
    return item.properties && item.properties._feschd_gift;
  }

  function giftLines(cart) {
    return cart.items.filter(isGift); // Reihenfolge: neueste zuerst
  }

  /* Duplikat-Schutz NUR gegen bestehende GESCHENK-Zeilen – vom Kunden selbst
     gekaufte Exemplare derselben Variante blockieren das Geschenk NICHT. */
  function giftVariantInCart(cart, variantId) {
    return giftLines(cart).some(function (g) { return g.variant_id === variantId; });
  }

  /* Qualifizierender Betrag – deckungsgleich mit der Rabatt-Logik:
     Geschenk-Zeilen nie; Flaschen-Kaufzeilen (tier1) nie; Mount-Kaufzeilen
     (tier2) mit ORIGINAL-Preis (rabattstabil); Rest mit final_line_price.
     Begründung: Doku-Kopf, Punkt 4. */
  function qualifyingTotal(cart, cfg) {
    return cart.items.reduce(function (sum, i) {
      if (isGift(i)) return sum;
      if (cfg.tier1Variants.indexOf(i.variant_id) !== -1) return sum;
      if (cfg.tier2Variants.indexOf(i.variant_id) !== -1) return sum + i.original_line_price;
      return sum + i.final_line_price;
    }, 0);
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  /* Entfernen durch UNSER Aufräumen: Auto-Add-Sperre der Variante löschen,
     damit erneutes Erreichen der Stufe wieder hinzufügt. */
  function removeGiftLine(g) {
    return changeLine(g.key, 0).then(function (r) {
      removeFromIdList(AUTOADDED_IDS_KEY, g.variant_id);
      return r;
    });
  }

  function addGift(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { _feschd_gift: 'true' } }]
      })
    });
  }

  function refreshTheme() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function runSequential(operations) {
    return operations.reduce(function (chain, op) {
      return chain.then(op);
    }, Promise.resolve());
  }

  /* Entprellt evaluate() – mehrere Trigger kurz hintereinander laufen so nur einmal. */
  function scheduleEvaluate() {
    clearTimeout(evaluateTimer);
    evaluateTimer = setTimeout(evaluate, 120);
  }

  /* Konsistenz erzwingen (Schwellen, Anzahl, Tier-Sperren, Menge, Auto-Add, Aufräumen) */
  function evaluate() {
    var mod = getModule();
    if (!mod) {
      // Modul nicht gerendert (z. B. leerer Warenkorb): Session-Sperren
      // zurücksetzen, sobald der Warenkorb wirklich leer ist. Nur prüfen,
      // wenn überhaupt Sperren existieren (spart Requests).
      if (hasSessionFlags()) {
        fetchCart()
          .then(function (cart) {
            if (cart.item_count === 0) clearSessionFlags();
          })
          .catch(function () { /* egal */ });
      }
      return;
    }
    if (busy) { scheduleEvaluate(); return; }

    var cfg = readConfig(mod);

    setBusy(true);
    fetchCart()
      .then(function (cart) {
        // Leerer Warenkorb = Neustart: alle Session-Sperren zurücksetzen
        if (cart.item_count === 0) {
          clearSessionFlags();
          setBusy(false);
          return;
        }

        var total = qualifyingTotal(cart, cfg);
        var allowed = allowedCount(total, cfg);
        var tier2Reached = cfg.actionActive && cfg.threshold2 > 0 && total >= cfg.threshold2;
        var gifts = giftLines(cart);
        var operations = [];
        var keep = [];

        // 1) Tier-2-Artikel entfernen, wenn Stufe 2 nicht (mehr) erreicht ist.
        //    Das Tier-1-Geschenk bleibt IMMER liegen (Bundle-Skip greift erst
        //    beim Checkout-Klick, siehe Submit-Listener unten).
        gifts.forEach(function (g) {
          var isTier2 = cfg.tier2Variants.indexOf(g.variant_id) !== -1;
          if (isTier2 && !tier2Reached) {
            operations.push(function () { return removeGiftLine(g); });
          } else {
            keep.push(g);
          }
        });

        // 1b) Wahl-Modus Stufe 2: maximal EIN Tier-2-Geschenk – überzählige
        //     (neueste zuerst) entfernen, bevor das Gesamt-Maximum greift.
        if (cfg.tier2Choice) {
          var tier2Kept = keep.filter(function (g) {
            return cfg.tier2Variants.indexOf(g.variant_id) !== -1;
          });
          while (tier2Kept.length > 1) {
            var extra = tier2Kept.shift();
            keep.splice(keep.indexOf(extra), 1);
            (function (g) {
              operations.push(function () { return removeGiftLine(g); });
            })(extra);
          }
        }

        // 2) Zu viele Geschenke: neueste zuerst entfernen (Index 0 = zuletzt
        //    hinzugefügt). Deckt auch allowed = 0 ab -> Aufräumen.
        while (keep.length > allowed) {
          var newest = keep.shift();
          (function (g) {
            operations.push(function () { return removeGiftLine(g); });
          })(newest);
        }

        // 3) Menge je Geschenk auf 1 begrenzen
        keep.forEach(function (g) {
          if (g.quantity > 1) {
            operations.push(function () { return changeLine(g.key, 1); });
          }
        });

        // 4) AUTO-ADD: Tier 1 (genau 1 konfigurierter Artikel) plus
        //    Tier-2-Artikel bei erreichter Stufe 2 – im Wahl-Modus
        //    (tier2Choice) fügt Stufe 2 NICHTS automatisch hinzu, der Kunde
        //    wählt selbst. Übersprungen wird NUR, wenn die Variante bereits
        //    als GESCHENK-Zeile im Warenkorb liegt, manuell entfernt oder
        //    abgewählt wurde. Vom Kunden gekaufte Exemplare blockieren das
        //    Geschenk NICHT – es kommt zusätzlich dazu.
        if (cfg.autoAdd && cfg.actionActive) {
          var targets = [];
          if (total >= cfg.threshold1 && cfg.tier1Variants.length === 1) {
            targets.push(cfg.tier1Variants[0]);
          }
          if (tier2Reached && !cfg.tier2Choice) {
            cfg.tier2Variants.forEach(function (v) { targets.push(v); });
          }
          var planned = 0;
          targets.forEach(function (variantId) {
            if (giftVariantInCart(cart, variantId)) return;
            if (isOptedOut(variantId) || wasAutoAdded(variantId)) return;
            if (keep.length + planned >= allowed) return;
            planned += 1;
            operations.push(function () {
              return addGift(variantId).then(function (r) {
                if (r && r.ok) addToIdList(AUTOADDED_IDS_KEY, variantId);
                return r;
              });
            });
          });
        }

        if (!operations.length) {
          setBusy(false);
          return;
        }

        return runSequential(operations).then(function () {
          setBusy(false);
          refreshTheme();
        });
      })
      .catch(function () { setBusy(false); });
  }

  /* Klick auf eine Geschenk-Option (Event-Delegation, überlebt Re-Renders) */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-feschd-gift-option]');
    if (!button || button.disabled) return;

    var mod = getModule();
    if (!mod || busy) return;

    event.preventDefault();

    var cfg = readConfig(mod);
    var chosenVariantId = Number(button.dataset.variantId);

    setBusy(true);
    fetchCart()
      .then(function (cart) {
        var total = qualifyingTotal(cart, cfg);
        var allowed = allowedCount(total, cfg);
        var tier2Reached = cfg.actionActive && cfg.threshold2 > 0 && total >= cfg.threshold2;
        var gifts = giftLines(cart);
        var operations = [];

        var existing = gifts.find(function (g) { return g.variant_id === chosenVariantId; });

        if (existing) {
          // Abwählen: entfernen + pro Variante für die Session merken,
          // damit der Auto-Add sie nicht sofort wieder hinzufügt
          addToIdList(OPTOUT_IDS_KEY, chosenVariantId);
          operations.push(function () { return changeLine(existing.key, 0); });
        } else {
          // Duplikat-Schutz: Variante liegt bereits als GESCHENK-Zeile im
          // Warenkorb -> nichts hinzufügen. Gekaufte Exemplare zählen nicht
          // als Duplikat (Geschenk kommt zusätzlich).
          if (giftVariantInCart(cart, chosenVariantId)) { setBusy(false); return; }

          var isTier2 = cfg.tier2Variants.indexOf(chosenVariantId) !== -1;

          if (allowed === 0) { setBusy(false); return; }
          if (isTier2 && !tier2Reached) { setBusy(false); return; }

          // Tausch INNERHALB derselben Stufe: liegt bereits ein anderes
          // Geschenk dieser Stufe im Warenkorb (z. B. Stufe-2-Wahl Mount vs.
          // Voucher), wird direkt getauscht – kein Optout, kein Maximum-Stopp.
          var sameTier = gifts.find(function (g) {
            if (g.variant_id === chosenVariantId) return false;
            if (isTier2) return cfg.tier2Variants.indexOf(g.variant_id) !== -1;
            return cfg.tier1Variants.indexOf(g.variant_id) !== -1;
          });

          if (sameTier) {
            operations.push(function () { return removeGiftLine(sameTier); });
            operations.push(function () { return addGift(chosenVariantId); });
          } else if (gifts.length < allowed) {
            operations.push(function () { return addGift(chosenVariantId); });
          } else if (allowed === 1 && gifts.length === 1) {
            // Direkt tauschen, wenn nur 1 Geschenk erlaubt ist
            var current = gifts[0];
            operations.push(function () { return changeLine(current.key, 0); });
            operations.push(function () { return addGift(chosenVariantId); });
          } else {
            // Maximum erreicht: Kunde muss zuerst abwählen (Hinweis im UI)
            setBusy(false);
            return;
          }
        }

        return runSequential(operations).then(function () {
          setBusy(false);
          refreshTheme();
        });
      })
      .catch(function () { setBusy(false); });
  });

  /* BUNDLE-SKIP BEIM CHECKOUT: Vor dem Absprung zur Kasse prüfen, ob ein
     Skip-Produkt (Hüllen-Bundle mit Flaschen-Komponente) UND die
     Tier-1-Geschenk-Zeile gleichzeitig im Warenkorb liegen -> Geschenk-Zeile
     entfernen (sonst doppelte Flasche im Auftrag), dann Submit fortsetzen. */
  function proceedSubmit(form, submitter) {
    form.setAttribute('data-feschd-gift-bypass', '1');
    if (typeof form.requestSubmit === 'function') {
      if (submitter && submitter.isConnected) {
        form.requestSubmit(submitter);
      } else {
        form.requestSubmit();
      }
    } else {
      if (submitter && submitter.name) {
        var h = document.createElement('input');
        h.type = 'hidden';
        h.name = submitter.name;
        h.value = submitter.value || '';
        form.appendChild(h);
      }
      form.submit();
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.getAttribute('data-feschd-gift-bypass') === '1') return;

    var submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;

    var mod = getModule();
    if (!mod) return;

    var cfg = readConfig(mod);
    if (!cfg.actionActive || !cfg.skipHandles.length || !cfg.tier1Variants.length) return;

    event.preventDefault();

    fetchCart()
      .then(function (cart) {
        var gift = giftLines(cart).find(function (g) {
          return cfg.tier1Variants.indexOf(g.variant_id) !== -1;
        });
        if (gift && tier1Skipped(cart, cfg)) {
          changeLine(gift.key, 0)
            .then(function () { proceedSubmit(form, submitter); })
            .catch(function () { proceedSubmit(form, submitter); });
        } else {
          proceedSubmit(form, submitter);
        }
      })
      .catch(function () { proceedSubmit(form, submitter); });
  }, true);

  /* Auf Warenkorbänderungen des Themes reagieren (Prestige-Events) */
  document.addEventListener('cart:change', scheduleEvaluate);
  document.addEventListener('cart:refresh', scheduleEvaluate);

  /* Re-Render des Drawers erkennen – fängt auch Custom-Add-to-Cart-Flows ab. */
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.id === 'feschd-free-gift' || (node.querySelector && node.querySelector('#feschd-free-gift'))) {
          scheduleEvaluate();
          return;
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', evaluate);
  } else {
    evaluate();
  }
})();
